import styled from "styled-components";

export const container = styled.div`
    grid-area: container-left;
    border-right: 1px solid #b8b4cc58;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: min(26rem, 25vw);
    position: fixed;
    height: 100vh;

    @media (max-width: 576px){
        width: 12vw;
    }
    

    & .logo-100pay{
        width: 12.5rem;
        height: auto;

        margin-top: 5rem;
        margin-bottom: 7rem;

        

        @media (max-width: 576px){
            display: none;
        }

        @media (min-width: 576px) and (max-width: 784.98px) {
            width: 10rem;
            height: auto;

            margin-top: 5rem;
            margin-bottom: 5rem;
        }

    }

    & .logo-sifrapag{
        background: #F6F5FA;
        padding: 2rem;
        border-radius: 10px;
        margin-top: 2rem;

        & img{
            width: 12.5rem;
            height: auto;
        }

        @media (max-width: 576px){
            display: none;
        }

        @media (min-width: 576px) and (max-width: 784.98px) {
            background: #F6F5FA;
            padding: 1.5rem;
            border-radius: 10px;
            margin-top: 3rem;

            & img{
                width: 9rem;
                height: auto;
            }
        }
    }

    @media (min-width: 767.98px) and (max-width: 999px){
        
        
    }

    @media (min-width: 999.98px) and (max-width: 1250px){

    }

`